import React, { Component } from 'react';

import { SendInvite } from './SendInvite'
import Swal from 'sweetalert2'
import $ from 'jquery';
//import Script from 'react-load-script';

export default class TeamAccounts extends Component {
    static displayName = TeamAccounts.name;
    _isMounted = false;

    constructor(props) {
        super(props);
        this.removeAccount = this.removeAccount.bind(this);
        this.saveSuccess = this.saveSuccess.bind(this);
        this.startInvite = this.startInvite.bind(this);
        this.state = {
            accounts: [], accNum: this.props.accNum, team: this.props.team, container: null, accountMessage: "Fetching Accounts...",
            inviteMessage: ""
        };

    }
    getData = async () => {

        const resp = await fetch('api/team/teamaccounts?teamid=' + encodeURIComponent(this.state.team.id), {
            method: 'GET',
            credentials: 'same-origin'
        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();

                //console.log(jdata);
                if (this._isMounted) {
                    await this.setState({ accounts: jdata, accountMessage:""});
                }

            } catch (e) {
                console.log(resp.statusText);
                this.setState({ accountMessage: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ accountMessage: '401: Not Authorized' })
        }
        else {
            this.setState({ accountMessage: 'There was a problem, please try again later' });
            
        }
    }



    startInvite = (e) => {
        e.preventDefault();

        $(".btn-invite").hide();
        this.setState({
            container: (<div class="row"><div class="col-xs-12"><div class="pull-right">
                <div class="alert alert-info">
                    Please note that only Gmail hosted accounts should be invited to GStitch for verification purposes.
                </div>
                {<SendInvite teamId={this.state.team.id} accNum={this.state.accNum} saveSuccess={this.saveSuccess} />}
            </div>
            </div></div>
            )
        })
    }
    removeAccount = (e, account) => {
        e.preventDefault();
        console.dir(account);
    }
    switchTeamLead = async (e, account) => {
        e.preventDefault();
        var data = { accountid: account.id, teamid: this.state.team.id };
        Swal.fire({
            title: 'Switch',
            text: 'Are you sure you want to promote ' + account.name + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes.',
            cancelButtonText: 'No.'
        }).then(async (result) => {
            if (result.value) {
                const resp = await fetch('api/team/switchteamlead', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                if (resp.status === 200) {
                    try {
                        const jdata = await resp.json();

                        if (this._isMounted && jdata.succeeded) {
                            //Reloads team list and closes modal
                            this.props.saveSuccess();
                        }

                    } catch (e) {
                        console.log(resp.statusText);
                        this.setState({ accountMessage: '500: Check console' })
                    }
                }
                else if (resp.status === 401) {
                    this.setState({ accountMessage: '401: Not Authorized' })
                }
                else {
                    this.setState({ accountMessage: 'There was a problem, please try again later' });
                  
                }
            }
        })
    }
    saveSuccess = () => {
        $(".btn-invite").show();
        //this.setState({ accountMessage: (<div class="alert alert-info fade-out">Invite Sent</div>), container:null });
        this.setState({ container: null });
        $("#sentConf").fadeIn(500, function () { $("#sentConf").fadeOut(3500) });
    }
    componentDidMount() {

        this._isMounted = true;
        (async () => {
            this.getData()
        })();

    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
       
        const constContainer = this.state.container;
    
        return (
            <div className="m15 container">
                <div className="my-2" style={{ minHeight: '50px' }} ><div className="alert alert-info "  id="sentConf" style={{ display: 'none' }}>Invite Sent</div></div>

                <div className="my-10">
                    {this.state.accounts.length > 0 ?
                        this.state.accounts.map(account =>
                            <Account key={account.id} {...account} removeAccount={(e, account) => this.removeAccount(e, account)}
                                switchTeamLead={(e, account) => this.switchTeamLead(e, account)}
                                ownerAccountId={this.state.accNum} />) :
                        ""}
                   
                </div>
                <div className="row">
                    <div className="col">
                        <button className="btn btn-secondary btn-invite" onClick={this.startInvite} >Invite Another</button>
                        {constContainer}
                      
                    </div>
                </div>

              
            </div>
        );
    }
}

class Account extends Component {

    render() {

        const removeButton = !(this.props.ownerAccountId === this.props.id) ? <button onClick={(e) => this.props.removeAccount(e, this.props)} >Remove Account</button> : "";
        const promoteButton = !(this.props.ownerAccountId === this.props.id) ? <button onClick={(e) => this.props.switchTeamLead(e, this.props)} >Make Owner</button> : "";
        return (
            //<div className="file-list mx-1">
           
            //</div>
            <div className="file-list mx-1 my-2 row ">
                <div className="col title">{this.props.name} </div>
                <div className="col ">{this.props.email} </div>
                <div className="col">
                    {removeButton}
                </div>
                <div className="col">
                    {promoteButton}
                </div>
            </div>
        );
    }
}
